import { Component, computed } from '@angular/core';
import { InternetConnectionService } from '../../services/internet-connection.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-offline',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './offline.component.html',
  styleUrl: './offline.component.css'
})
export class OfflineComponent {
  showOfflineBanner = computed(() => !this.network.online())
  constructor(private readonly network: InternetConnectionService) {}
}
